import * as React from 'react';

function SevereIcon(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
        fill="#EC6916"
      />
      <path
        d="M24.436 31.93c.073 0 .132-.119.129-.261-.07-4.878-2.087-8.791-4.568-8.791-2.48 0-4.497 3.913-4.567 8.79-.003.143.056.262.129.262h8.877ZM8.775 20.675a.81.81 0 0 1-.27-1.57l1.77-.625-1.686-.396a.808.808 0 1 1 .372-1.573l4.368 1.029a.807.807 0 0 1 .083 1.549l-4.368 1.54a.855.855 0 0 1-.269.046ZM31.223 20.675a.855.855 0 0 1-.27-.046l-4.368-1.54a.807.807 0 0 1 .084-1.55l4.368-1.028a.808.808 0 1 1 .372 1.573l-1.686.396 1.77.625a.81.81 0 0 1-.27 1.57Z"
        fill="#2B2523"
      />
    </svg>
  );
}

export default SevereIcon;
